import React, { useEffect, useState } from "react";
import { Collapse } from "antd";
import { useTranslation } from "react-i18next";
import { useNewTrialState } from "../../../pages/new-trail/hooks/NewTrialStateProvider";
import { formatTranslation } from "../../utils/translationUtils";
import { getProductUnit } from "../../../pages/create-protocol/utils";
import StandardBiologicalRate from "../BiologicalRate";
import "./TreatmentComponent.less";
const { Panel } = Collapse;

interface Treatment {
  id: string;
  name: string;
  products: Array<{
    name: string;
    rate: string;
    unit: string;
  }>;
  notes: any;
  tankMixRate: any;
  timings: any[];
}

const TreatmentComponent = (): React.ReactElement => {
  const { t } = useTranslation();
  const { trialProtocolData } = useNewTrialState();
  const [treatments, setTreatments] = useState<Treatment[]>([]);
  useEffect(() => {
    if (trialProtocolData?.product_details?.biologicals?.treatments) {
      const formattedTreatments =
        trialProtocolData.product_details.biologicals.treatments
          .flat()
          .map((treatment, index) => ({
            id: `treatment-${index}`,
            name: `Treatment ${index + 1}`,
            products: treatment.products.map(
              (product: {
                variety: any;
                rate: { toString: () => any };
                measure_unit: any;
              }) => ({
                name: product.variety,
                rate: product.rate.toString(),
                unit: product.measure_unit,
              })
            ),
            notes: treatment.instructions,
            tankMixRate: treatment.tank_mix_rate,
            timings: [],
          }));
      setTreatments(formattedTreatments);
    }
  }, [trialProtocolData]);
  return (
    <div className="treatment-component">
      <Collapse
        accordion
        className="main-accordion"
        defaultActiveKey={["treatments"]}
      >
        <Panel
          header={formatTranslation(t("trials.treatments"))}
          key="treatments"
          className="main-panel"
        >
          <Collapse
            className="nested-accordion"
            activeKey={treatments.map((treatment) => treatment.id)} // keep all panels open
            expandIcon={() => null} // hide collapse arrow
          >
            {treatments.map((treatment, tIndex) => (
              <Panel
                header={treatment.name}
                key={treatment.id}
                className="treatment-panel"
              >
                {/* Products Section */}
                {treatment?.products.length > 0 && (
                  <div className="products-section">
                    <div style={{ display: "flex", gap: 24 }}>
                      <div className="products-notes-col" style={{ flex: 1 }}>
                        <div className="treatment-products">
                          {treatment?.products.map((product, index) => (
                            <div key={index} className="product-row">
                              <div className="product-name">
                                <div className="product-value">
                                  {product.name}
                                  <span className="product-unit">
                                    {` ${String(
                                      getProductUnit(product?.unit)
                                    )}`}
                                  </span>
                                </div>
                              </div>
                              <div className="product-seed-rate">
                                <div className="seed-rate-value">
                                  {product.rate}
                                  <span className="rate-unit">
                                    {` ${String(
                                      getProductUnit(product?.unit)
                                    )}`}
                                  </span>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                      <div
                        className="biological-rate-col"
                        style={{ textAlign: "start", marginRight: "6px" }}
                      >
                        <StandardBiologicalRate
                          treatmentIndex={tIndex}
                          treatmentData={treatment}
                        />
                      </div>
                    </div>
                    {/* Application Notes */}
                    {treatment.notes && (
                      <div className="notes-section">
                        <div className="section-title">
                          {formatTranslation(t("trials.instructions"))}
                        </div>
                        <div className="treatment-notes">
                          <div className="notes-content">{treatment.notes}</div>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </Panel>
            ))}
          </Collapse>
        </Panel>
      </Collapse>
    </div>
  );
};
export default TreatmentComponent;
